import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IsauthorizedService } from 'src/app/shared/services/isauthorized.service';

@Injectable()
export class ManageProjectsGuard  {

  constructor(
    private router: Router, private isAuthorizedService: IsauthorizedService) {
  }

  canActivate(): Observable<boolean> | boolean {
    if (this.isAuthorizedService.checkControlAuthorization('subTabManageProjects')) {
      return true;
    }
    this.router.navigate(['/'], { replaceUrl: true });
  }


  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isAuthorizedService.checkControlAuthorization('subTabManageProjects')) {
      return true;
    }
    this.router.navigate(['/'], { replaceUrl: true });
  }
}
